 document.addEventListener('DOMContentLoaded', function () {
    if (!window.cardSwiperInitialized) {
      window.cardSwiperInitialized = true;
      
      const initCardSwipers = () => {
        document.querySelectorAll('.card-media-slider').forEach(wrapper => {
          const swiperEl = wrapper.querySelector('.card-product-swiper:not(.swiper-initialized)');
          const paginationEl = wrapper.querySelector('.swiper-pagination');
          
          if (!swiperEl) return; 

          new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: paginationEl,
              clickable: true
            },
            navigation: {
              nextEl: wrapper.querySelector('.swiper-button-next'),
              prevEl: wrapper.querySelector('.swiper-button-prev'),
            }
          });
        });
      };
      
      initCardSwipers();
      
      const observer = new MutationObserver(initCardSwipers);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });